module.exports = __webpack_public_path__ + "media/images/partners/zamani-6aa5a7f1b9237aa511137fca12c77010.jpeg";